import viewTypes from 'helpers/enums/viewTypes'

const viewsWithoutIcons = [
	viewTypes.CT_CREATE,
	viewTypes.CT_ADMIN,
	viewTypes.APP_CHECKOUT,
	viewTypes.CT_REFERRAL,
	viewTypes.MY_ACCOUNT,
	viewTypes.OEQ_CREATION,
	viewTypes.POLL_CREATION,
	viewTypes.DRAW_IT_CREATION,
	viewTypes.QUIZ_CREATION,
	viewTypes.MATCHING_PAIRS_CREATION,
	viewTypes.FLOCABULARY_CREATION,
	viewTypes.DESMOS_CREATION,
	viewTypes.TIME_TO_CLIMB_CREATION,
	viewTypes.UPGRADE_ACCOUNT,
	viewTypes.QUICK_LAUNCH_OEQ_ACTIVITY_CREATION,
	viewTypes.QUICK_LAUNCH_DRAW_IT_ACTIVITY_CREATION,
	viewTypes.INTERACTIVE_VIDEO_CREATE,
	viewTypes.INTERACTIVE_VIDEO_CREATION_MCQ,
	viewTypes.INTERACTIVE_VIDEO_CREATION_OEQ,
	viewTypes.VIDEO_CREATE,
	viewTypes.VIDEO_CREATION_MCQ,
	viewTypes.VIDEO_CREATION_OEQ,
	viewTypes.FLIPGRID_CREATION,
]

export default viewsWithoutIcons
